import {
  styled,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { Menu, ExitToApp, ArrowBack } from "@mui/icons-material";
import { auth } from "../../services";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  selectMenuOptionSlice,
  selectOpenDrawerSlice,
  setOpenDrawer,
} from "../../store/slices/global";
import { NavIcon } from "./nav-icon";

interface BarProps {
  title: string;
  secondary?: boolean;
}

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: 240,
    width: `calc(100% - ${240}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Header: FC<BarProps> = ({ title, secondary }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const menuOption = useAppSelector(selectMenuOptionSlice);
  const open = useAppSelector(selectOpenDrawerSlice);

  const logout = (path: string) => {
    auth.logout();
    history.replace(path);
  };

  const goBackMain = () => {
    history.push(menuOption?.path);
  };

  return (
    <AppBar position="fixed" open={open}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => dispatch(setOpenDrawer(true))}
          edge="start"
          sx={{
            marginRight: 5,
            ...(open && { display: "none" }),
          }}
        >
          <Menu />
        </IconButton>
        {secondary ? (
          <Tooltip title={menuOption?.label}>
            <ArrowBack
              onClick={goBackMain}
              sx={{ marginRight: "12px", cursor: "pointer" }}
            />
          </Tooltip>
        ) : (
          <NavIcon name={menuOption?.icon} margin={true} />
        )}
        <Typography variant="h6" noWrap component="div">
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Tooltip title="Cerrar sesión">
            <IconButton
              size="large"
              edge="end"
              aria-label="cerrar sesión"
              color="inherit"
              onClick={() => logout("/auth/login")}
            >
              <ExitToApp />
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export { Header };
